module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-regular-400.svg?606e54f607334e45061aab955bbabe29";